export default {
  layout: {
    aiCommandCentre: {
      badge: 'Centre de commande IA',
      line:
        'Allocation autonome transporteurs et chauffeurs, planification de routes agentique, alertes intelligentes et agents IA — une tour de contrôle qui pilote toute la logistique.',
      cta: 'Agents IA',
    },
  },
};
